import config from 'config';

const patterns = [
  // FL Policies
  /^(SJ3|SJ6)\d{7}$/, // SJ3XXXXXXX
  /^(SIC3|SIC6)\d{6}$/, // SIC3XXXXXX
  /^SJF\d{7}$/, // SJFXXXXXXX (shared)
  /^SIF(?!1)\d{7}$/, // SIFXXXXXXX (shared, excluding SIF1)
  /^H[36]FL\d{9}$/, // H3FLXXXXXXXXX o H6FLXXXXXXXXX
  /^D3FL\d{9}$/, // D3FLXXXXXXXXX
  /^D1FL\d{9}$/, // D1FLXXXXXXXXX

  // SC Policies
  /^(SC3|SC6)\d{7}$/, // SC3XXXXXX
  /^(SCH3|SCH6)\d{6}$/, // SC3XXXXXX
  /^(HOSC|H6SC)\d{9}$/, // HOSCXXXXXXXXX o H6SCXXXXXXXXX

  //NY Policies
  /^H[36]NY\d{9}$/, // H3NYXXXXXXXXX o H6NYXXXXXXXXX

  //NJ Policies
  /^H[36]NJ\d{9}$/, // H3NJXXXXXXXXX o H6NJXXXXXXXXX

  //Fusion Policies
  /^H[36]FF\d{9}$/, // H3FLXXXXXXXXX o H6FLXXXXXXXXX

  //TX Policies
  /^H[36]TX\d{9}$/, // H3FLXXXXXXXXX o H6FLXXXXXXXXX

  //RI Policies
  /^D1RI\d{9}$/, // D1RIXXXXXXXXX
  /^D3RI\d{9}$/, // D3RIXXXXXXXXX
];

const isLowEnv = config.appEnv !== 'PROD';
const currentPatterns = [
  ...patterns,
  ...(isLowEnv
    ? [/^SICC[36]\d{6}$/, /^(SIFF)\d{6}$/, /^SF1\d{7}$/] // SICC3/SICC6, SIFF, SF1 (lower envs)
    : [/^SIF1\d{6}$/]), // SIF1 (PROD)
];

export const policyNumber = (rawInput = '') => {
  const containsAlphanumericAndSpacesOnly = /^[0-9A-Za-z ]+$/.test(rawInput);
  const atLeast10Alphanumeric = rawInput.split(' ').join('').length >= 10;
  if (!currentPatterns.some((regex) => regex.test(rawInput))) {
    return false;
  }
  return containsAlphanumericAndSpacesOnly && atLeast10Alphanumeric;
};

export const policyNumberPayment = (rawInput = '') => {
  if (!rawInput || rawInput.trim() === '') {
    return 'Policy number is required';
  }
  const beginning = rawInput.slice(0, 2).toUpperCase();
  const firstChar = rawInput.charAt(0).toUpperCase();
  const validPrefixes = ['H3', 'H6', 'HO', 'D3', 'D1'];

  if (!validPrefixes.includes(beginning) && firstChar !== 'S') {
    return 'Only policies beginning with H3, H6, HO, D3, D1 or S can create an account at this time';
  }

  if (!currentPatterns.some((regex) => regex.test(rawInput))) {
    return 'Policy number is invalid.';
  }
};

export default {
  policyNumber,
  policyNumberPayment,
};
